import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { UserService } from 'src/app/services/user.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-edit-address',
  templateUrl: './edit-address.component.html',
  styleUrls: ['./edit-address.component.css']
})
export class EditAddressComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private usersService: UserService, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  onUpdate(form: NgForm) {

    const data = new FormData();
    data.append('_id', form.value._id);
    data.append('contactPerson', form.value.contactPerson);
    data.append('mobile', `+94${form.value.mobile}`);
    data.append('houseNo', form.value.houseNo);
    data.append('building', form.value.building || '-');
    data.append('street', form.value.street);
    data.append('city', form.value.city);

    this.usersService.updateAddress(data).subscribe(result => {
      const localUser = localStorage.getItem('user');
      const user = JSON.parse(localUser);

      user.addresses = result.data.addresses;
      const stringyUser = JSON.stringify(user);
      localStorage.setItem('user', stringyUser);

      this.usersService.setAddresses(result.data.addresses);

      this.snackBar.open('Address successfully updated', 'Dismiss', {
        duration: 3000
      })

      this.dialog.closeAll();
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      })
    })
  }
}
